import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Image from 'lib/images/image-view';

import Avatar from 'four-nets/avatar/avatar';
import { displayedName } from 'four-nets/user/utils';

import { GroupPrivacy } from '../../group-loader.graphql.types';
import mutation, {
    InviteUserToGroupMutation,
    InviteUserToGroupMutationVariables,
} from './mutations/invite-user-to-group.graphql';
import { RecommendedUserFragment } from './recommended-user.graphql';
import defaultStyles from './recommended-user.scss';

export interface Props extends RecommendedUserFragment {
    styles: typeof defaultStyles;
    groupId: string;
    privacyType: GroupPrivacy;
    refetch: () => void;
}

interface State {
    loading: boolean;
}

class RecommendedUser extends React.PureComponent<Props, State> {
    state: State = { loading: false };

    render() {
        const {
            styles,
            groupId,
            id,
            username,
            socialName,
            wasInvitedToGroupByViewer,
            privacyType,
            profile,
        } = this.props;

        return (
            <li className={styles.recommendedUser} key={id}>
                <div className={styles.user}>
                    <Avatar style={{ avatar: styles.avatar }} user={this.props} />
                    <Link
                        to={profile && profile.isVendor ? `/catalog/vendor/${username}/` : `/blog/${username}/`}
                        className={styles.link}
                    >
                        {displayedName({ username, socialName })}
                    </Link>
                </div>
                <Mutation<InviteUserToGroupMutation, InviteUserToGroupMutationVariables> mutation={mutation}>
                    {mutationFn => (
                        <button
                            className={styles.button}
                            onClick={() => {
                                this.setState({ loading: true });
                                mutationFn({
                                    variables: {
                                        input: { groupId, username },
                                        groupId,
                                    },
                                })
                                    .then(() => this.props.refetch())
                                    .finally(() => this.setState({ loading: false }));
                            }}
                            disabled={Boolean(wasInvitedToGroupByViewer) || this.state.loading}
                        >
                            {privacyType === GroupPrivacy.GROUP_PRIVACY_PRIVATE ? (
                                <FormattedMessage id='BUTTON_LABEL_ADD' />
                            ) : (
                                <FormattedMessage id='INVITE' />
                            )}
                        </button>
                    )}
                </Mutation>
            </li>
        );
    }
}

export default Styled(defaultStyles)(RecommendedUser);
